<sz-modal
  [width]="width + 'px'"
  [height]="height + 'px'"
  [showTitle]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [(visible)]="visible"
  >
  <div class="p-8 modal-content flex flex-col justify-between h-full">
    <div>
      <div class="flex flex-col items-center max-w-sm">
        <img src="../../../../assets/icons/question.svg" [width]=" bigIcon ? 103 : 64" [height]=" bigIcon ? 103 : 64" alt="icon-question"/>
        @if (title) {
          <label class="my-8 text-dark-grey font-medium text-3xl text-center">
            {{title}}
          </label>
        }
        @if (message) {
          <p class="text-base font-normal text-light-grey-300 min-w-[20rem]" [class.text-center]="textCenter">
            {{message}}
          </p>
        }
        <ng-content></ng-content>
      </div>
    </div>
    <div class="flex justify-around mt-8 w-full">
      <button class="sz-btn-primary mx-3.5 w-full h-[48px]"
        (click)="handleConfirm()"
        [disabled]="isConfirming || loadingData.visible">
        @if (isConfirming || loadingData.visible) {
          <i class="fa-solid fa-spinner fa-spin mr-2"></i>
        }
        {{confirmBtnText}}
      </button>
      <button class="sz-btn-outline mx-3.5 w-full h-[48px]"
        (click)="handleCancel()">
        {{cancelBtnText}}
      </button>
    </div>
  </div>
</sz-modal>
